import React from "react";
import type { GetStaticProps, GetStaticPaths } from "next";
import type { PathProps } from "@riot-private/blades-ui/blades-api-client";

import config from "../utils/env";
import { fetchPageProps } from "../utils/api/fetchPageProps";
import {
  BladesRendererPage,
  PagePropsWithMeta,
} from "../components/pages/BladesRendererPage";

export default function Page(props: PagePropsWithMeta) {
  return <BladesRendererPage {...props} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [], // Empty array because you don't want to pre-render any pages at build time
    fallback: "blocking", // Generate pages on-the-fly when a request comes in
  };
};

export const getStaticProps: GetStaticProps<
  PagePropsWithMeta,
  PathProps
> = async ({ params, locales, locale = "en-us" }) => {
  try {
    const result = await fetchPageProps({
      params,
      locales,
      locale,
      revalidateTtl: config.DEFAULT_ISR_PAGE_TTL,
    });
    return result;
  } catch (error) {
    console.error(`ERROR: ${error}`, { params, locales });
    throw error;
  }
};
